/**
 * The client feedback keys (server/feedback.ts), held once for the page: the
 * Repos view draws a card per repo, each showing that repo's keys, and one read
 * serves them all. Global settings lists every key from the same list.
 */
import { ref } from "vue";
import { api } from "./api.js";
import type { FeedbackKey } from "@shared/feedback.js";

/** null until read. */
export const feedbackKeys = ref<FeedbackKey[] | null>(null);
/** The board's own button's parent; undefined until read, so a picker cannot write over it. */
export const boardParentId = ref<string | null | undefined>(undefined);
export const feedbackKeysError = ref("");

let inflight: Promise<void> | null = null;

/** Read again; calls while one is in flight share it. */
export function loadFeedbackKeys(): Promise<void> {
  inflight ??= api
    .get<{ keys: FeedbackKey[]; boardParentId?: string | null }>("/api/feedback-keys")
    .then((r) => {
      feedbackKeys.value = r.keys;
      boardParentId.value = r.boardParentId ?? null;
      feedbackKeysError.value = "";
    })
    .catch((err: unknown) => {
      feedbackKeysError.value = err instanceof Error ? err.message : String(err);
    })
    .finally(() => (inflight = null));
  return inflight;
}
